import * as managers from 'app/mocks/data/park/managers/list'

import { Konvive } from 'app/types/users/konvive'

export const konvive1: Konvive = {
    id: 1,
    client: managers.manager8,
    email: 'raven.lucie@konvives.com',
    first_name: 'Lucie',
    last_name: 'RAVEN',
    phone: '0632556684',
    card_number: 'ADADZ123',
}

export const konvive2: Konvive = {
    id: 2,
    client: managers.manager3,
    email: 'john.doe@konvives.com',
    first_name: 'John',
    last_name: 'DOE',
    phone: '74852',
}

export const konvive3: Konvive = {
    id: 3,
    client: managers.manager5,
    email: 'alice.smith@konvives.com',
    first_name: 'Alice',
    last_name: 'SMITH',
    phone: '98263',
    card_number: 'XYZA789',
}

export const konvive4: Konvive = {
    id: 4,
    client: managers.manager2,
    email: 'bob.rose@konvives.com',
    first_name: 'Bob',
    last_name: 'ROSE',
    phone: '64532',
}

export const konvive5: Konvive = {
    id: 5,
    client: managers.manager1,
    email: 'emma.miller@konvives.com',
    first_name: 'Emma',
    last_name: 'MILLER',
    phone: '72109',
    card_number: 'PLMN890',
}

export const konvive6: Konvive = {
    id: 6,
    client: managers.manager7,
    email: 'carlos.lopez@konvives.com',
    first_name: 'Carlos',
    last_name: 'LOPEZ',
    phone: '56387',
    card_number: 'UIOP567',
}

export const konvive7: Konvive = {
    id: 7,
    client: managers.manager6,
    email: 'sarah.white@konvives.com',
    first_name: 'Sarah',
    last_name: 'WHITE',
    phone: '85973',
    card_number: 'kLMN234',
}

export const konvive8: Konvive = {
    id: 8,
    client: managers.manager4,
    email: 'james.martin@konvives.com',
    first_name: 'James',
    last_name: 'MARTIN',
    phone: '93721',
    card_number: 'VCXZ345',
}

export const konvive9: Konvive = {
    id: 9,
    client: managers.manager9,
    email: 'michael.davis@konvives.com',
    first_name: 'Michael',
    last_name: 'DAVIS',
    phone: '67482',
}

export const konvive10: Konvive = {
    id: 10,
    client: managers.manager10,
    email: 'rachel.lee@konvives.com',
    first_name: 'Rachel',
    last_name: 'LEE',
    phone: '54698',
}

export const konvive11: Konvive = {
    id: 11,
    client: managers.manager11,
    email: 'luis.garcia@konvives.com',
    first_name: 'Luis',
    last_name: 'GARCIA',
    phone: '87912',
    card_number: 'ASDF456',
}

export const konvive12: Konvive = {
    id: 12,
    client: managers.manager12,
    email: 'maria.rodriguez@konvives.com',
    first_name: 'Maria',
    last_name: 'RODRIGUEZ',
    phone: '76329',
}

export const konvive13: Konvive = {
    id: 13,
    client: managers.manager13,
    email: 'thomas.lopez@konvives.com',
    first_name: 'Thomas',
    last_name: 'LOPEZ',
    phone: '62834',
}

export const konvive14: Konvive = {
    id: 14,
    client: managers.manager14,
    email: 'paul.walker@konvives.com',
    first_name: 'Paul',
    last_name: 'WALKER',
    phone: '39847',
    card_number: 'MNOP789',
}

export const konvive15: Konvive = {
    id: 15,
    client: managers.manager15,
    email: 'jessica.young@konvives.com',
    first_name: 'Jessica',
    last_name: 'YOUNG',
    phone: '45298',
}

export const konvive16: Konvive = {
    id: 16,
    client: managers.manager16,
    email: 'benjamin.hernandez@konvives.com',
    first_name: 'Benjamin',
    last_name: 'HERNANDEZ',
    phone: '94123',
}

export const konvive17: Konvive = {
    id: 17,
    client: managers.manager17,
    email: 'karen.scott@konvives.com',
    first_name: 'Karen',
    last_name: 'SCOTT',
    phone: '87642',
    card_number: 'ZXCQ890',
}

export const konvive18: Konvive = {
    id: 18,
    client: managers.manager18,
    email: 'robert.king@konvives.com',
    first_name: 'Robert',
    last_name: 'KING',
    phone: '53984',
}

export const konvive19: Konvive = {
    id: 19,
    client: managers.manager19,
    email: 'tina.taylor@konvives.com',
    first_name: 'Tina',
    last_name: 'TAYLOR',
    phone: '38495',
    card_number: 'OLQP678',
}

export const konvive20: Konvive = {
    id: 20,
    client: managers.manager20,
    email: 'martin.moore@konvives.com',
    first_name: 'Martin',
    last_name: 'MOORE',
    phone: '64879',
}

export const konvive21: Konvive = {
    id: 21,
    client: managers.manager21,
    email: 'julia.thomas@konvives.com',
    first_name: 'Julia',
    last_name: 'THOMAS',
    phone: '72563',
    card_number: 'SDTR789',
}

export const konvive22: Konvive = {
    id: 22,
    client: managers.manager8,
    email: 'william.jackson@konvives.com',
    first_name: 'William',
    last_name: 'JACKSON',
    phone: '49721',
}

export const konvive23: Konvive = {
    id: 23,
    client: managers.manager5,
    email: 'emily.clark@konvives.com',
    first_name: 'Emily',
    last_name: 'CLARK',
    phone: '58293',
    card_number: 'JKSD1234',
}

export const konvive24: Konvive = {
    id: 24,
    client: managers.manager12,
    email: 'michael.smith@konvives.com',
    first_name: 'Michael',
    last_name: 'SMITH',
    phone: '67382',
}

export const konvive25: Konvive = {
    id: 25,
    client: managers.manager2,
    email: 'sophia.johnson@konvives.com',
    first_name: 'Sophia',
    last_name: 'JOHNSON',
    phone: '78965',
    card_number: 'OPQR2345',
}

export const konvive26: Konvive = {
    id: 26,
    client: managers.manager17,
    email: 'daniel.martin@konvives.com',
    first_name: 'Daniel',
    last_name: 'MARTIN',
    phone: '83627',
    card_number: 'ZXCV6789',
}

export const konvive27: Konvive = {
    id: 27,
    client: managers.manager9,
    email: 'olivia.white@konvives.com',
    first_name: 'Olivia',
    last_name: 'WHITE',
    phone: '94726',
}

export const konvive28: Konvive = {
    id: 28,
    client: managers.manager21,
    email: 'ethan.brown@konvives.com',
    first_name: 'Ethan',
    last_name: 'BROWN',
    phone: '35298',
}

export const konvive29: Konvive = {
    id: 29,
    client: managers.manager1,
    email: 'ava.davis@konvives.com',
    first_name: 'Ava',
    last_name: 'DAVIS',
    phone: '61748',
    card_number: 'GHJK7890',
}

export const konvive30: Konvive = {
    id: 30,
    client: managers.manager1,
    email: 'liam.garcia@konvives.com',
    first_name: 'Liam',
    last_name: 'GARCIA',
    phone: '72839',
}
